import React from 'react';
import { Button, Input } from '@roo/roo';
import {
    BaseFeeInfoTypeEnum,
    CONTRACT_TYPE,
    CommissionInfoTypeEnum,
    IEffectHostingInfoSignFormRate,
} from '../api';

// const { useState, useEffect } = React;

interface IProps {
    value: IEffectHostingInfoSignFormRate[];
    handleChange: (value: IEffectHostingInfoSignFormRate[]) => void;
    commissionType: CommissionInfoTypeEnum;
    baseFeeType: BaseFeeInfoTypeEnum;
    coopMode: number;
}

const Index = (props: IProps) => {
    const { value, handleChange, commissionType, baseFeeType, coopMode } = props;

    const handleInputChange = (
        key: keyof IEffectHostingInfoSignFormRate,
        idx: number,
        e: React.ChangeEvent<HTMLInputElement>,
    ) => {
        let val = e.target.value.trim();
        const arr = value.slice(0);
        // 不符合数字格式
        if (!/^\d*\.?\d*$/.test(val)) {
            return;
        }
        // 比例最大20
        if (key === 'rate' && parseFloat(val) > 20) {
            val = '20';
        }
        // 基础服务费一口价时，需要限制抽佣比例的左值必须≥1
        if (
            key === 'rate' &&
            baseFeeType === BaseFeeInfoTypeEnum.FixedPrice &&
            parseFloat(val) < 1
        ) {
            val = '1';
        }
        // 上限最大两千万
        if (key !== 'rate' && parseFloat(val) > 20000000) {
            val = '20000000';
        }
        // 不是最后一个阶梯的右值修改需要同步到下一个阶梯的左值
        if (key === 'intervalEnd' && idx < value.length - 1) {
            arr[idx + 1].intervalBegin = val;
        }
        // if (key === 'intervalBegin') {
        //     // 左值修改的场景只有第一个阶梯
        //     const earningsThresholdNum = parseFloat(earningsThreshold) || 0;
        //     if (parseFloat(val) < earningsThresholdNum) {
        //         val = earningsThreshold || '0';
        //     }
        // }
        arr[idx][key] = val;
        handleChange(arr);
    };

    const handleAdd = () => {
        if (!value) return;
        const arr = value.slice(0);
        const lastRight = arr[arr.length - 1].intervalEnd;
        arr.push({ intervalBegin: lastRight, intervalEnd: '', rate: '' });
        handleChange(arr);
    };

    const handleDelete = () => {
        if (!value) return;
        const arr = value.slice(0);
        arr.pop();
        handleChange(arr);
    };

    const renderItem = (item: IEffectHostingInfoSignFormRate, idx: number) => {
        const str = commissionType === CommissionInfoTypeEnum.All ? '全额抽佣' : '实收增量部分';
        return (
            <p style={{ display: 'flex', alignItems: 'center' }}>
                <Input
                    value={item.intervalBegin}
                    style={{ width: '80px' }}
                    disabled={idx !== 0}
                    onChange={e => {
                        handleInputChange('intervalBegin', idx, e);
                    }}
                />
                元≤商家日实收＜
                <Input
                    value={item.intervalEnd}
                    style={{ width: '80px' }}
                    onChange={e => {
                        handleInputChange('intervalEnd', idx, e);
                    }}
                />
                元，{str}抽佣比例为
                <Input
                    value={item.rate}
                    style={{ width: '80px' }}
                    onChange={e => {
                        handleInputChange('rate', idx, e);
                    }}
                />
                %&nbsp;
                {
                    // 直播cps禁止增加阶梯
                    value && idx === value.length - 1 && coopMode !== CONTRACT_TYPE.LIVE_CPS && (
                        <>
                            <Button
                                className="feild-btn"
                                onClick={handleAdd}
                                disabled={value.length === 5}
                            >
                                +
                            </Button>
                            <Button
                                className="feild-btn"
                                onClick={handleDelete}
                                disabled={value.length === 1}
                            >
                                -
                            </Button>
                        </>
                    )
                }
            </p>
        );
    };

    return <>{value && value.map((item, idx) => renderItem(item, idx))}</>;
};

export default Index;
